<template>
    <div>
      <lot-alien-details v-if="lot" :lot="lot" :bidId="bidId"></lot-alien-details>
      <loading v-if="loading"></loading>
    </div>
</template>

<script>
  import LotAlienDetails from './AlienDetails'

  export default {
    components: {
      LotAlienDetails
    },

    computed: {
      lotId() {
        return +this.$route.params.lotId;
      },

      requestId() {
        return +this.$route.params.requestId;
      },

      bidId() {
        const bidParam = this.$route.params.bidId + "";
        return bidParam.indexOf('num-') === 0 ? undefined : +bidParam;
      },

      tab() {
        return this.$route.params.tab;
      },

      lot() {
        return this.$store.getters.otherRequest(this.lotId, this.requestId);
      }
    },

    beforeRouteEnter(to, from, next) {
      next(async vm =>  {
        await vm.loadRequest();
        vm.validateRoute(to);
      });
    },

    beforeRouteUpdate(to, from, next) {
      this.validateRoute(to);
      next();
    },

    methods: {
      loadRequest() {
        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchRequest', {
              lotId: this.lotId,
              requestId: this.requestId
            });
          }
          catch(e) {
            console.error('failed fetching alien request', e);
            this.globalErrorHandler(e);
          }
        });
      },

      validateRoute(to) {
        const bidParam = to.params.bidId + "";
        let bidId;

        if (bidParam.indexOf('num-') === 0) {
          const bidNum = +bidParam.slice(4);
          const bids = _.get(this.lot, 'request.bids', []);
          bidId = _.get(_.find(bids, { num: bidNum }), 'id');
        }

        if (bidId) {
          // redirect to bid by id
          this.$router.replace({
            name: 'purchases-public-lot-alien-bid',
            params: {
              lotId: this.lotId,
              requestId: this.requestId,
              bidId: bidId,
              tab: this.tab
            }
          });
        }
      }
    }
  }
</script>

<style scoped>

</style>
